import { ProviderType, type Transaction } from "@digits-graphql/frontend/graphql-bearer"

const DELETABLE_PROVIDER_TYPES = new Set([ProviderType.CSVImport, ProviderType.Manual])

export const canDeleteTransaction = (transaction: Transaction) =>
  transaction.providerTypes.every((providerType) => isProviderTypeDeletable(providerType))

export const isProviderTypeDeletable = (providerType: ProviderType) =>
  DELETABLE_PROVIDER_TYPES.has(providerType)
